import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, LoadProducts } from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

replaceInChain(chain, LoadProducts, props => {
    if (!props.getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = props.extraProductCollectionParameter
        ? {
              getProductCollectionParameter: props.extraProductCollectionParameter,
              numberOfProductsToDisplay: props.parameter.numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP =
        props.parameter.carouselType === "recentlyViewed" && props.parameter.isProductDetailsPage;

    props.getProductCollectionParameter.expand
        ? props.getProductCollectionParameter.expand.push("images", "properties")
        : (props.getProductCollectionParameter.expand = ["images", "properties"]);

    props.dispatch(
        loadProductInfoList({
            id: props.parameter.carouselId,
            getProductCollectionParameter: props.getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? props.parameter.productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit: props.parameter.isShellEdit,
        }),
    );
});
